import React from 'react'
import { connect } from 'react-redux'

import ImagePreview from '../image-preview/ImagePreview'
import { bindActionCreators, compose } from 'redux'
import { withTranslation } from 'react-i18next'
import { t } from 'i18next'

import { changePortal, removeProfileImage } from '../../../actions/portal'
import PortalGalleryImage from '../portal-gallery-image/PortalGalleryImage'
import PortalLinkImage from '../portal-link/PortalLinkImage'
import GooglePickerImage from '../../../modules/google-picker/GooglePickerImage'
import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import { IMAGE_ACTION_MODAL } from '../../../constants/modalType'
import ImagesUploader from '../../../modules/images-upload/ImagesUploader'
import ImageEmptySection from './ImageEmptySection'
class ImageManagementContainer extends React.Component {
  static propTypes = {
    ...modalPropTypes,
  }

  state = {}
  componentDidMount() {
    // this.props.modalActions.showModal(IMAGE_ACTION_MODAL, { imageFile: null })
  }

  handleImagePicked = imageFile => {
    this.props.modalActions.showModal(IMAGE_ACTION_MODAL, { imageFile })
  }

  handleDropFile = e => {
    e.preventDefault()
    const files = e.target.files
    const imageFile = files[0]
    if (imageFile) {
      this.props.modalActions.showModal(IMAGE_ACTION_MODAL, { imageFile })
    }
    e.target.value = ''
  }

  handleProfileImageRemove = imageID => {
    if (window.confirm(t('alert.deleteImage.label'))) {
      this.props.actions.removeProfileImage(imageID)
    }
  }

  render() {
    const { profileImageID, profileImageLastChecked, i18n } = this.props

    return (
      <div>
        <div className="has-text-right">
          <div className="field">
            <div className="file is-right is-info">
              <label className="file-label">
                <input
                  className="file-input"
                  type="file"
                  name="files"
                  onChange={this.handleDropFile}
                />
                <span className="file-cta">
                  <span className="file-icon">
                    <i className="fas fa-upload" />
                  </span>
                  <span className="file-label">
                    {i18n.t('actions.uploadImage.label')}
                  </span>
                </span>
              </label>
              <div style={{ marginLeft: 6 }}>
                <GooglePickerImage onImagePicked={this.handleImagePicked} />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="columns">
          {/* <div className="column is-4" style={{ background: 'hsl(0, 0%, 96%)' }}> */}
          {/* <ImageStore /> */}
          {/* </div> */}
          <div className="column is-12">
            <h1 className="title is-3">{i18n.t('profileImage.label')}</h1>

            {profileImageID ? (
              <div style={{ maxWidth: 125 }}>
                <ImagePreview
                  style={{ maxWidth: 250 }}
                  imageID={profileImageID}
                  lastChecked={profileImageLastChecked}
                  onImageRemove={this.handleProfileImageRemove}
                />
              </div>
            ) : (
              <ImageEmptySection />
            )}

            <hr />
            <h1 className="title is-3">{i18n.t('galleryImage.label')}</h1>
            <PortalGalleryImage />
            <hr />
            <h1 className="title is-3">{i18n.t('linkImage.label')}</h1>
            <PortalLinkImage />
            <hr />
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  withTranslation(),
  withReduxModal,
  connect(
    ({ portal }) => ({
      portalID: portal._id,
      profileImageID: portal.mainImageId,
      profileImageLastChecked: portal.mainImageLastChecked,
    }),
    dispatch => ({
      actions: bindActionCreators(
        { changePortal: changePortal, removeProfileImage: removeProfileImage },
        dispatch,
      ),
    }),
  ),
)(ImageManagementContainer)



// WEBPACK FOOTER //
// ./src/components/templates/image-management/ImageManagementContainer.js